import React, { memo } from 'react'
import styled from 'styled-components'
import { Spacings, Text } from '@styles'

const Row = styled.div`
	display: flex;
	flex-wrap: nowrap;
	align-items: center;
	gap: ${Spacings.SPACING_2};
	overflow-x: auto;
	font-family: ${({ theme }) => theme.fontFamily.inter};
	background: transparent;
	padding: ${Spacings.SPACING_5} 0;

	&::-webkit-scrollbar {
		display: none;
	}
	-ms-overflow-style: none;
	scrollbar-width: none;
`

// filled rounded pill: selected → light-blue bg + blue text, else light-grey bg + dark text
const Pill = styled.button`
	flex: 0 0 auto;
	max-width: 18rem;
	padding: ${Spacings.SPACING_2B} ${Spacings.SPACING_3B};
	border-radius: ${({ theme }) => theme.radius.md};
	border: none;
	background: ${({ theme, $selected }) => ($selected ? '#CFE0FF' : theme.colors.surface.sunken)};
	color: ${({ theme, $selected }) => ($selected ? theme.colors.brand.primary : theme.colors.text.primary)};
	font-size: ${Text.SMALL};
	font-weight: ${({ $selected }) => ($selected ? Text.BOLD_600 : Text.BOLD_500)};
	font-family: inherit;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	cursor: pointer;
	transition: all 0.15s ease-in-out;

	&:hover {
		background: ${({ theme, $selected }) => ($selected ? '#CFE0FF' : theme.colors.surface.overlay)};
	}
`

// Pill-style tab bar. Same data shape as the V2 Tabs component:
// data = [{ label, selected, onClick, hide }]
const PillTabs = memo(({ data, onTabClick, ...props }) => {
	const visibleTabs = data?.filter((tab) => !tab.hide) || []

	return (
		<Row {...props}>
			{visibleTabs.map((tab, idx) => (
				<Pill
					key={tab.label || idx}
					$selected={tab.selected}
					title={typeof tab.label === 'string' ? tab.label : undefined}
					onClick={() => {
						if (typeof onTabClick === 'function') onTabClick(tab)
						else if (typeof tab.onClick === 'function') tab.onClick()
					}}
				>
					{tab.label}
				</Pill>
			))}
		</Row>
	)
})

export default PillTabs
